<template>
  <div    
  v-if="userIsAdmin || userIsIntern"
    class="sector-select"
    :class="[openSidenav ? isSidenavOpen : isSidenavClose]"
  >
    <el-select
      v-model="value"
      filterable
      remote
      clearable
      @change="select"
      @clear="clearSector"
      reserve-keyword
      placeholder="Buscar sector"
      no-data-text="No se encontro el sector"
      :remote-method="remoteMethod"
      :loading="loading"
    >
      <el-option
        class="optionsectores"
        v-for="item in options"
        :key="item.is"
        :label="item.name"
        :value="item.name"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
import dataSectores from "./zonas/sectores_claro";

export default {
  data() {
    return {
      marker: null,
      isSidenavOpen: "openSidenavSector",
      isSidenavClose: "closedSidenavSector",
      openSidenav: false,
      datasectores: dataSectores,
      options: [],
      value: [],
      list: [],
      loading: false,
      userIsBasic: false,
      userIsAdmin: false,
      userIsIntern: false,
    };
  },
  computed: {
    ...mapState(["map", "user"]),
  },
  watch: {
    user(newValue, oldValue) {
      console.log("WATCH USER");
      this.userIsBasic = newValue.roles.includes("ROLE_USER");
      this.userIsAdmin = newValue.roles.includes("ROLE_ADMIN");
      this.userIsIntern = newValue.roles.includes("ROLE_CONSULTANT");
      console.log(newValue.roles);
      console.log(this.userIsAdmin);
    },
  },
  mounted() {
    let app = this;
    this.$store.watch(this.$store.getters.isOpenSidenav, (openSidenav) => {
      app.openSidenav = openSidenav;
    });
  },
  methods: {
    remoteMethod(query) {
   
      if (query !== "") {
        this.loading = true;

        this.options = this.datasectores.filter((item) => {
        
          return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });

        this.loading = false;
      } else {
        this.options = [];
      }
    },
    select(value) {
      if (value) {
        if (this.marker) {
          this.map.removeLayer(this.marker);
        }

        let sector = this.datasectores.find((obj) => {
          return obj.name === value;
        });

        var latlng = L.latLng(sector.y, sector.x);

        this.marker = L.marker(latlng)
          .addTo(this.map)
          .bindPopup(sector.name)
          .openPopup();

        this.map.setView(latlng, 16, {
          duration: 1,
        });
      }
    },
    clearSector() {
      if (this.marker) {
        
        this.map.removeLayer(this.marker);
      }
    },
  },
};
</script>

<style >
.sector-select {
  top: 0px;
  left: 10px;
  position: fixed;
  -webkit-transition: 0.22s;
  transition: 0.22s;
  z-index: 1000;
  /* -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02); */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0 rgba(0, 0, 0, 0.02); */
}

.openSidenavSector {
  /* left: 330px; */
  left: 725px;
  margin-top: 70px;
}

.closedSidenavSector {
  /* left: 10px; */
  left: 405px;
  margin-top: 70px;
}

.el-scrollbar {
  width: 280px !important;
}
</style>